import { getMint } from '@solana/spl-token'
import { PublicKey } from '@solana/web3.js'
import { useWallet } from '@solana/wallet-adapter-react'
import { connection } from 'solana-bc/connection'
import { useGetSmartContract } from 'shared/hooks/use-smart-contracts'
import { Web3Adress } from 'shared/types'
import {
  depositSolana,
  getPlayerDepositSolana,
  withdrawSolana
} from 'solana-bc/treasury-calls'

export const useTreasury = (
  _smartContractAddress: Web3Adress,
  _smartContractVersion: number
) => {
  const wallet = useWallet()
  const { smartContractAddress: usdcMintAddress } = useGetSmartContract('USDC')

  if (!wallet?.publicKey) return undefined
  if (!usdcMintAddress) return undefined

  const tokenMint = new PublicKey(usdcMintAddress)

  const loadTreasuryBalance = async () => {
    const d = await getPlayerDepositSolana(wallet.publicKey!, tokenMint)
    if (!d) return '0'
    const mintInfo = await getMint(connection, tokenMint)
    const raw = Number(d.account.balance.toString())
    const human = raw / 10 ** mintInfo.decimals
    return String(human)
  }

  const depositTokens = async (amountTokens: number) => {
    return depositSolana(wallet, amountTokens, tokenMint)
  }

  /** Without `amount` the whole deposit is withdrawn. */
  const withdrawTokens = async (amount?: string) => {
    return withdrawSolana(wallet, tokenMint, amount)
  }

  return {
    depositTokens,
    withdrawTokens,
    loadTreasuryBalance
  }
}
